import { Component, OnInit } from '@angular/core';
import { SchedulerService } from '../../services/scheduler/scheduler.service';
import { SessionStorageService } from '../../auth/services/session.service';
import { forkJoin } from 'rxjs';
declare var $: any;

@Component({
  selector: 'app-scheduler',
  templateUrl: './scheduler.component.html',
  styleUrls: ['./scheduler.component.css']
})
export class SchedulerComponent implements OnInit {

  data: any[] = [];
  loading: boolean = false;
  error: string = '';

  private schedulerNames: string[] = [];

  // Mapeo: código de constante → display name
  private readonly constantToDisplay: { [key: string]: string } = {
    'REP_TOTAL_CUS': 'Reporte Total Customer',
    'REP_EASY_CUS': 'Reporte Easy Customer',
    'REP_TOTAL_PROS': 'Reporte Total Prospect',
    'REP_EASY_PROS': 'Reporte Easy Prospect'
  };

  // Se llena dinámicamente con valor de constante → display name
  displayNames: { [key: string]: string } = {};

  dayLabels: string[] = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'];
  monthNames: string[] = [
    'Enero','Febrero','Marzo','Abril','Mayo','Junio',
    'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'
  ];

  private readonly dayNamesMap: { [key: string]: string } = {
    '1': 'Domingo',
    '2': 'Lunes',
    '3': 'Martes',
    '4': 'Miércoles',
    '5': 'Jueves',
    '6': 'Viernes',
    '7': 'Sábado'
  };

  translateDescripcion(descripcion: string): string {
    if (!descripcion) return '';

    // Reemplazar rangos como "1 a 5" → "Domingo a Jueves"
    let result = descripcion.replace(/(\d)\s+a\s+(\d)/g, (match, from, to) => {
      const fromName = this.dayNamesMap[from] || from;
      const toName = this.dayNamesMap[to] || to;
      return `${fromName} a ${toName}`;
    });

    // Reemplazar listas como "1, 3, 4, 5, 6, 7" → nombres de días
    result = result.replace(/(\d)(?:\s*,\s*(\d))+/g, (match) => {
      const nums = match.split(',').map(n => n.trim());
      // Si son los 7 días, mostrar "Todos los días"
      if (nums.length === 7) {
        const allDays = ['1','2','3','4','5','6','7'];
        if (allDays.every(d => nums.includes(d))) {
          return 'Todos los días';
        }
      }
      return nums.map(num => this.dayNamesMap[num] || num).join(', ');
    });

    // Si el rango es "1 a 7" o "Domingo a Sábado", también es todos los días
    result = result.replace(/Domingo a Sábado/g, 'Todos los días');

    // Reemplazar números sueltos que queden (un solo dígito 1-7 rodeado de espacios o inicio/fin)
    result = result.replace(/(?<=^|\s)([1-7])(?=\s|$)/g, (match, num) => {
      return this.dayNamesMap[num] || num;
    });

    return result;
  }

  constructor(private schedulerService: SchedulerService,
              private sessionStorageService: SessionStorageService) {
    if (!this.sessionStorageService.hasRolesUser(['AMX_ADMIN']) &&
        !this.sessionStorageService.hasInternalRolesUser(['AMX_INT_ADMIN'])) {
      this.sessionStorageService.redirectToLogin();
    }
  }

  selectedItem: any = null;
  observaciones: any[] = [];
  showObservaciones: boolean = false;
  constants: any = {};
  selectedDays: any[] = [];
  showConfirm: boolean = false;
  changesSummary: string[] = [];
  private originalEjecuciones: string[] = [];
  private maxSelectableDate: Date = null;
  private snapshotItem: any = null;

  openEditPopup(item: any): void {
    this.selectedItem = JSON.parse(JSON.stringify(item));
    this.selectedDays = [];
    this.showConfirm = false;
    this.changesSummary = [];
    this.originalEjecuciones = [...(item.proximasEjecuciones || [])];

    // Guardar snapshot del estado original para restaurar si cancelan
    this.snapshotItem = JSON.parse(JSON.stringify(this.selectedItem));

    // Calcular fecha máxima seleccionable (última de las 10 ejecuciones)
    if (this.originalEjecuciones.length > 0) {
      const lastExec = this.originalEjecuciones[this.originalEjecuciones.length - 1];
      const [d, m, y] = lastExec.split(' ')[0].split('/').map(Number);
      this.maxSelectableDate = new Date(y, m - 1, d);
      this.maxSelectableDate.setHours(23, 59, 59, 999);
    } else {
      this.maxSelectableDate = null;
    }

    this.selectedItem.calendarMonths.forEach(m => {
      m.weeks.forEach(w => {
        w.forEach(c => c.selected = false);
      });
    });
    ($('#editSchedulerModal') as any).modal('show');
  }

  selectDay(cell: any, month: any): void {
    if (this.showConfirm) return;

    const parts = month.label.split(' ');
    const year = +parts[1];
    const monthIndex = this.monthNames.indexOf(parts[0]);
    const cellDate = new Date(year, monthIndex, cell.day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (cellDate < today) return;

    // No permitir seleccionar días posteriores a la última ejecución
    if (this.maxSelectableDate && cellDate > this.maxSelectableDate) return;

    // Si ya está seleccionado, verificar si es un día nuevo (no original) para poder deseleccionarlo
    if (cell.selected) {
      const dateLabel = `${String(cell.day).padStart(2, '0')}/${String(monthIndex + 1).padStart(2, '0')}/${year}`;
      const wasOriginal = this.originalEjecuciones.some(o => o.startsWith(dateLabel));
      if (!wasOriginal) {
        // Es un día nuevo que se agregó, se puede quitar clickeando de nuevo
        cell.selected = false;
        this.selectedDays = this.selectedDays.filter(s => s.cell !== cell);
      }
      return;
    }

    // Si está highlighted, pasarlo a selected (es para quitar)
    let isRemoval = false;
    if (cell.highlighted) {
      cell.highlighted = false;
      cell.selected = true;
      isRemoval = true;
    } else {
      cell.selected = true;
      isRemoval = false;
    }

    let time = '00:00:00';
    if (this.selectedItem.proximasEjecuciones && this.selectedItem.proximasEjecuciones.length > 0) {
      time = this.selectedItem.proximasEjecuciones[0].split(' ')[1];
    }

    const dayStr = String(cell.day).padStart(2, '0');
    const monthStr = String(monthIndex + 1).padStart(2, '0');
    const dateLabel = `${dayStr}/${monthStr}/${year}`;

    // Buscar horario original de esa fecha
    const original = (this.selectedItem.proximasEjecuciones || []).find(f => f.startsWith(dateLabel));
    if (original) {
      time = original.split(' ')[1];
    }

    this.selectedDays.push({ label: dateLabel, time, cell, isRemoval });
  }

  deselectDayOfWeek(sel: any): void {
    if (this.showConfirm) return;

    const [day, month, year] = sel.label.split('/').map(Number);
    const targetDate = new Date(year, month - 1, day);
    const targetDow = targetDate.getDay();

    // Quitar highlight y selected de TODOS los días del mismo día de semana
    this.selectedItem.calendarMonths.forEach(m => {
      const parts = m.label.split(' ');
      const mYear = +parts[1];
      const mMonth = this.monthNames.indexOf(parts[0]);

      m.weeks.forEach(week => {
        week.forEach(cell => {
          if (!cell.day) return;
          const cellDate = new Date(mYear, mMonth, cell.day);
          if (cellDate.getDay() === targetDow) {
            cell.selected = false;
            cell.highlighted = false;
          }
        });
      });
    });

    // Quitar de selectedDays todos los del mismo día de semana
    this.selectedDays = this.selectedDays.filter(s => {
      const [d, mo, y] = s.label.split('/').map(Number);
      const sDate = new Date(y, mo - 1, d);
      return sDate.getDay() !== targetDow;
    });
  }

  saveScheduler(): void {
    this.changesSummary = this.buildChangesSummary();
    this.showConfirm = true;
  }

  confirmSave(): void {
    const cronExpression = this.buildCronExpression();
    this.loading = true;

    this.schedulerService.updateScheduler(this.selectedItem.name, cronExpression).subscribe(
      (response) => {
        this.loading = false;
        this.showConfirm = false;
        ($('#editSchedulerModal') as any).modal('hide');
        this.loadExecutions();
        this.loadObservaciones();
      },
      (err) => {
        this.loading = false;
        this.showConfirm = false;
        this.error = JSON.stringify(err, null, 2);
      }
    );
  }

  cancelSave(): void {
    this.showConfirm = false;
    // Restaurar el calendario al estado original (cuando se abrió el popup)
    this.selectedItem = JSON.parse(JSON.stringify(this.snapshotItem));
    this.selectedDays = [];
  }

  private buildCronExpression(): string {
    // Recopilar los días activos (highlighted que no fueron removidos + seleccionados)
    const activeDays: { day: number, month: number, year: number, time: string }[] = [];

    // Días que siguen highlighted
    this.selectedItem.calendarMonths.forEach(m => {
      const parts = m.label.split(' ');
      const mYear = +parts[1];
      const mMonth = this.monthNames.indexOf(parts[0]);

      m.weeks.forEach(week => {
        week.forEach(cell => {
          if (cell.day && cell.highlighted) {
            const dateStr = `${String(cell.day).padStart(2, '0')}/${String(mMonth + 1).padStart(2, '0')}/${mYear}`;
            const original = this.originalEjecuciones.find(o => o.startsWith(dateStr));
            const time = original ? original.split(' ')[1] : '00:00:00';
            activeDays.push({ day: cell.day, month: mMonth, year: mYear, time });
          }
        });
      });
    });

    // Días seleccionados (nuevos o con horario editado)
    this.selectedDays.forEach(sel => {
      const [d, mo, y] = sel.label.split('/').map(Number);
      // Evitar duplicados
      const exists = activeDays.find(a => a.day === d && a.month === mo - 1 && a.year === y);
      if (exists) {
        exists.time = sel.time; // Actualizar horario
      } else {
        activeDays.push({ day: d, month: mo - 1, year: y, time: sel.time });
      }
    });

    // Determinar minuto y hora del primer día activo (o el más común)
    let minutes = '0';
    let hours = '0';
    if (activeDays.length > 0) {
      const [h, m] = activeDays[0].time.split(':');
      hours = String(+h);
      minutes = String(+m);
    }

    // Determinar días de la semana activos
    const daysOfWeek = new Set<number>();
    activeDays.forEach(ad => {
      const date = new Date(ad.year, ad.month, ad.day);
      daysOfWeek.add(date.getDay());
    });

    // Mapear a formato AWS cron (1=DOM, 2=LUN, ..., 7=SAB)
    const awsDowMap = [1, 2, 3, 4, 5, 6, 7]; // JS getDay() 0=Dom → AWS 1=DOM
    const dowValues = Array.from(daysOfWeek).map(d => awsDowMap[d]).sort();

    const dowStr = dowValues.length > 0 ? dowValues.join(',') : '?';

    // cron(minutos hora dia-mes mes dia-semana año)
    return `cron(${minutes} ${hours} ? * ${dowStr} *)`;
  }

  private buildChangesSummary(): string[] {
    const summary: string[] = [];

    // Construir nuevo estado: días highlighted + días selected
    const newDays: Set<string> = new Set();

    this.selectedItem.calendarMonths.forEach(m => {
      const parts = m.label.split(' ');
      const mYear = parts[1];
      const mMonth = this.monthNames.indexOf(parts[0]);
      const monthStr = String(mMonth + 1).padStart(2, '0');

      m.weeks.forEach(week => {
        week.forEach(cell => {
          if (cell.day && (cell.highlighted || cell.selected)) {
            const dayStr = String(cell.day).padStart(2, '0');
            newDays.add(`${dayStr}/${monthStr}/${mYear}`);
          }
        });
      });
    });

    // Días agregados (están activos ahora pero no estaban en el original)
    const selectedDatesMap = new Map<string, string>();
    this.selectedDays.forEach(sel => {
      selectedDatesMap.set(sel.label, sel.time);
    });

    newDays.forEach(dateStr => {
      const originalMatch = this.originalEjecuciones.find(o => o.startsWith(dateStr));
      if (!originalMatch) {
        const time = selectedDatesMap.get(dateStr) || '00:00:00';
        summary.push(`Se habilitó ${dateStr} ${time}`);
      }
    });

    // Días removidos (estaban en original pero ya no están activos)
    const originalDates = this.originalEjecuciones.map(o => o.split(' ')[0]);
    originalDates.forEach((dateStr, i) => {
      if (!newDays.has(dateStr)) {
        summary.push(`Se desactivó ${this.originalEjecuciones[i]}`);
      }
    });

    // Días con horario modificado
    this.selectedDays.forEach(sel => {
      const originalMatch = this.originalEjecuciones.find(o => o.startsWith(sel.label));
      if (originalMatch) {
        const originalTime = originalMatch.split(' ')[1];
        if (originalTime !== sel.time) {
          summary.push(`Se modificó ${sel.label} horario ${originalTime} → ${sel.time}`);
        }
      }
    });

    if (summary.length === 0) {
      summary.push('No se detectaron cambios.');
    }

    return summary;
  }

  ngOnInit(): void {
    this.loadConstants();
    this.loadObservaciones();
  }

  isPastDay(day: number, month: any): boolean {
    const parts = month.label.split(' ');
    const year = +parts[1];
    const monthIndex = this.monthNames.indexOf(parts[0]);
    const cellDate = new Date(year, monthIndex, day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return cellDate < today;
  }

  isOutOfRange(day: number, month: any): boolean {
    if (!this.maxSelectableDate) return false;
    const parts = month.label.split(' ');
    const year = +parts[1];
    const monthIndex = this.monthNames.indexOf(parts[0]);
    const cellDate = new Date(year, monthIndex, day);
    return cellDate > this.maxSelectableDate;
  }

  loadConstants(): void {
    const codigos = ['REP_TOTAL_PROS', 'REP_TOTAL_CUS', 'REP_EASY_PROS', 'REP_EASY_CUS'];
    this.loading = true;
    this.schedulerService.getConstantsByCodigos(codigos).subscribe(
      (data: any) => {
        this.constants = data;
        // Armar schedulerNames y displayNames desde las constantes
        const items = Array.isArray(data) ? data : (data.data || []);
        this.schedulerNames = [];
        this.displayNames = {};
        items.forEach((item: any) => {
          if (item.valor && item.codigo) {
            this.schedulerNames.push(item.valor);
            this.displayNames[item.valor] = this.constantToDisplay[item.codigo] || item.valor;
          }
        });
        this.loadExecutions();
      },
      (err) => {
        console.error('Error cargando constantes', err);
        this.constants = {};
        this.loading = false;
      }
    );
  }

  loadObservaciones(): void {
    this.schedulerService.getObservaciones().subscribe(
      (data: any) => {
        if (Array.isArray(data)) {
          this.observaciones = data;
        } else if (data && data.data) {
          this.observaciones = Array.isArray(data.data) ? data.data : [data.data];
        } else if (data) {
          this.observaciones = [data];
        } else {
          this.observaciones = [];
        }
      },
      (err) => {
        console.error('Error cargando observaciones', err);
        this.observaciones = [];
      }
    );
  }

  toggleObservaciones(): void {
    this.showObservaciones = !this.showObservaciones;
  }

  isString(item: any): boolean {
    return typeof item === 'string';
  }

  loadExecutions(): void {
    this.loading = true;
    this.error = '';

    const requests = this.schedulerNames.map(name =>
      this.schedulerService.getExecutions(name)
    );

    forkJoin(requests).subscribe(
      (responses: any[]) => {
        this.data = responses.map(r => {
          const fechas = r.proximasEjecuciones || [];
          const parsedDates = this.parseDates(fechas);
          return {
            name: r.name,
            descripcionLegible: r.descripcionLegible,
            proximasEjecuciones: fechas,
            calendarMonths: this.buildCalendarMonths(parsedDates)
          };
        });
        this.loading = false;
      },
      (err) => {
        this.error = JSON.stringify(err, null, 2);
        this.loading = false;
      }
    );
  }

  private parseDates(fechas: string[]): Date[] {
    if (!fechas || fechas.length === 0) return [];
    return fechas
      .map(f => {
        try {
          const parts = f.split(' ');
          const [day, month, year] = parts[0].split('/');
          return new Date(+year, +month - 1, +day);
        } catch (e) {
          return null;
        }
      })
      .filter(d => d !== null && !isNaN(d.getTime()));
  }

  private buildCalendarMonths(dates: Date[]): any[] {
    if (dates.length === 0) return [];

    // Agrupar fechas por mes
    const monthMap = new Map<string, Set<number>>();
    dates.forEach(d => {
      const key = `${d.getFullYear()}-${d.getMonth()}`;
      if (!monthMap.has(key)) monthMap.set(key, new Set());
      monthMap.get(key).add(d.getDate());
    });

    const months = [];
    monthMap.forEach((highlightedDays, key) => {
      const [year, month] = key.split('-').map(Number);
      const firstDay = new Date(year, month, 1).getDay();
      const totalDays = new Date(year, month + 1, 0).getDate();

      const weeks: any[][] = [];
      let week: any[] = [];

      // Espacios vacíos antes del primer día
      for (let i = 0; i < firstDay; i++) {
        week.push({ day: null, highlighted: false });
      }

      for (let day = 1; day <= totalDays; day++) {
        week.push({ day, highlighted: highlightedDays.has(day) });
        if (week.length === 7) {
          weeks.push(week);
          week = [];
        }
      }

      // Completar última semana
      while (week.length > 0 && week.length < 7) {
        week.push({ day: null, highlighted: false });
      }
      if (week.length > 0) weeks.push(week);

      months.push({
        label: `${this.monthNames[month]} ${year}`,
        weeks
      });
    });

    return months;
  }
}
